<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Copyright--Front-Matter-"><span class="CharOverride-2">The Sleep of Baby Filbertson</span><span class="CharOverride-3"><br/><br/></span><span class="CharOverride-2">Copyright © 1959 by James Leo Herlihy</span><span class="CharOverride-3"><br/><br/></span><span class="CharOverride-2">All rights Copyright Owner Jeffrey J. Bailey</span><span class="CharOverride-3"><br/><br/></span><span class="CharOverride-2">Cover art and Electronic Edition © 2018 by RosettaBooks LLC</span></p>
<p class="ORIM-Copyright--Front-Matter-"><span class="CharOverride-2">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</span></p>
<p class="ORIM-Copyright--Front-Matter-"><span class="CharOverride-2">Cover jacket design by Christian Fuenfhausen</span><span class="CharOverride-3"><br/><br/></span><span class="CharOverride-2">ISBN e-Pub edition: 9780795351204</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Baby_F_epub17.vue?d1b69cec